import { render, staticRenderFns } from "./pc-contact.vue?vue&type=template&id=06be0087&scoped=true"
import script from "./pc-contact.vue?vue&type=script&lang=js"
export * from "./pc-contact.vue?vue&type=script&lang=js"
import style0 from "./pc-contact.vue?vue&type=style&index=0&id=06be0087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06be0087",
  null
  
)

export default component.exports